import React, { useState } from "react";
import Footer from "./Footer";
import "./AIProjects.css";

function parseProjectDate(value) {
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
}

function AIProjects({ data }) {
  const [filterBy, setFilterBy] = useState("All");
  const projects = data?.projects || [];

  const categories = ["All", ...new Set(projects.map((project) => project.where).filter(Boolean))];
  const filteredProjects = [...projects]
    .sort((a, b) => parseProjectDate(b.start_date) - parseProjectDate(a.start_date))
    .filter((project) => filterBy === "All" || project.where === filterBy);

  if (!data) return null;

  return (
    <main className="projects-page">
      <header className="projects-hero">
        <div className="page-shell projects-hero__inner">
          <p className="section-kicker section-kicker--dark">Project archive</p>
          <h1>Work that moves from<br />ambition to operation.</h1>
          <div className="projects-hero__intro">
            <p>
              A selection of data, AI and machine-learning systems developed
              across corporate, consulting and founder-led work.
            </p>
            <span>{projects.length.toString().padStart(2, "0")} projects</span>
          </div>
        </div>
      </header>

      <section className="projects-content">
        <div className="page-shell">
          <div className="projects-toolbar">
            <p>Filter by context</p>
            <div className="project-filters" aria-label="Filter projects">
              {categories.map((category) => (
                <button
                  key={category}
                  className={filterBy === category ? "is-active" : ""}
                  type="button"
                  aria-pressed={filterBy === category}
                  onClick={() => setFilterBy(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          <div className="projects-list" aria-live="polite">
            {filteredProjects.map((project, index) => (
              <article className="project-detail" key={`${project.name}-${project.start_date}`}>
                <div className="project-detail__rail">
                  <span>{(index + 1).toString().padStart(2, "0")}</span>
                  <span>{project.start_date}</span>
                </div>

                <div className="project-detail__main">
                  <div className="project-detail__title">
                    <h2>{project.name}</h2>
                    <button type="button" onClick={() => setFilterBy(project.where)}>
                      {project.where}
                    </button>
                  </div>

                  <p className="project-detail__description">{project.description}</p>

                  <div className="project-detail__facts">
                    {project.scale && (
                      <div>
                        <h3>Overview</h3>
                        <p>{project.scale}</p>
                      </div>
                    )}
                    {project.impact && (
                      <div>
                        <h3>Impact</h3>
                        <p>{project.impact}</p>
                      </div>
                    )}
                    {project.technology && (
                      <div>
                        <h3>Technology</h3>
                        <p>{project.technology}</p>
                      </div>
                    )}
                  </div>

                  {project.roles?.length > 0 && (
                    <div className="project-detail__roles">
                      <h3>My role</h3>
                      <ul>
                        {project.roles.map((role) => <li key={role}>{role}</li>)}
                      </ul>
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer data={data.main} />
    </main>
  );
}

export default AIProjects;
